import { ToastContainer } from 'react-toastify';
import RootRoute from './routes/RootRoute';
import './App.scss';

function App() {
  return (
    <div className="App" data-testid="App">
      <RootRoute />

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
